import type { Proposal, ProposalStatus } from 'api/projectVersioning/types';
import { formateDate } from 'utils/StringFormatter';

const getUpdatedLabel = (status: ProposalStatus) => {
  if (status === 'Merged' || status === 'Discarded') return status;
  return 'Updated';
};

export const buildProposalSecondaryText = (proposal: Proposal) => {
  if (!proposal.created) {
    return '';
  }

  const statusPrefix = proposal.status === 'Draft' ? 'Draft · ' : '';
  const createdText = `${statusPrefix}Created: ${formateDate(proposal.created, 'YYYY/MM/DD')}`;

  if (!proposal.updated) {
    return createdText;
  }

  const updatedText = `${getUpdatedLabel(proposal.status)}: ${formateDate(proposal.updated, 'YYYY/MM/DD')}`;

  return `${createdText} · ${updatedText}`;
};
